module.exports = __webpack_public_path__ + "img/BR.5fa3cc06.svg";